import forgotPasswordTemplate from './email-templates/forgot-password';

export const forgotPassword = {
  emailTemplate: forgotPasswordTemplate,
};

export default {
  forgotPassword,
};
